<div class="frame-in">
  <div class="items south-america-3-frame">
    <svg class="road south-america-3">
      <style type="text/css">
        tspan {
        white-space: pre
      }

      .shp0 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 5;
      stroke-dasharray: 15,15
    }
  </style>
  <defs>
    <filter filterUnits="userSpaceOnUse" id="Filter_0" x="420.5px" y="-2.5px" width="159px" height="181px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_1" x="203.5px" y="12.5px" width="233px" height="88px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_2" x="71.5px" y="102.5px" width="221px" height="168px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_3" x="-2.5px" y="164.5px" width="66px" height="133px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>
  <g filter="url(#Filter_0)">
    <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
      d="M568.499,166.499 C568.499,166.499 569.184,139.110 554.499,132.499 C539.815,125.889 504.677,130.577 497.499,116.499 C490.322,102.422 487.779,87.123 486.499,68.499 C485.220,49.876 485.394,2.834 457.499,8.499 C429.605,14.165 428.499,23.499 428.499,23.499 " />
    </g>
    <g filter="url(#Filter_1)">
      <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
        d="M208.499,88.499 C208.499,88.499 209.47,48.425 238.499,36.499 C267.952,24.574 296.543,21.66 330.499,26.499 C360.735,31.337 410.775,23.379 430.499,17.499 " />
      </g>
      <g filter="url(#Filter_2)">
        <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
          d="M210.499,110.499 C210.499,110.499 203.137,163.439 227.499,171.499 C251.862,179.560 281.858,176.516 284.499,196.499 C287.141,216.483 293.298,263.785 257.499,260.499 C221.700,257.214 167.352,225.408 133.499,226.499 C99.647,227.591 95.332,222.756 76.499,258.499 " />
        </g>
        <g filter="url(#Filter_3)">
          <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
            d="M56.499,284.499 C56.499,284.499 17.43,296.402 10.499,276.499 C3.956,256.597 0.869,212.882 5.500,204.499 C10.130,196.117 29.731,184.379 29.499,170.499 " />
          </g>
        </svg>
        <div class="country south-america-3"></div>
        <div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 13, 'active': quizLevel === 13 && tick2Quiz}"></div>

        @for (zone of zones; track zone) {
          <div>
            <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
          </div>
        }

        @for (zone of zones; track zone; let i = $index) {
          <div
            class="poi {{zone.class}}"
            [ngClass]="{active: zone.active, 'lock': zone.locked}"
            (mouseenter)="mouseEnter(zone)"
            (mouseleave)="mouseLeave(zone)"
            (click)="selectZone(zone)">
            <span>{{ zone.locked ? '' : zone.number}}</span>
          </div>
        }
      </div>
    </div>

    <img class="frame-title" src="assets/images/zones/south-america-3/title.png">

    <audio id="introductionAudio" (ended)="playBgAudio()">
      <source src="assets/sounds/country.wav" type="audio/wav">
    </audio>
    <audio id="bgAudio" (ended)="playIntroductionAudio()">
      <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
    </audio>

    @if (showNotification) {
      <div class="alert-pop-up" style="z-index: 99999999 !important" (click)="closeNotification()">
        <div class="alert-pop-up-in" style="text-align: -webkit-center;">
          <h3>
            This lesson has not been released yet. <br />It is coming soon.
          </h3>
          <button style="margin-right: 0px !important" (click)="closeNotification()" mat-flat-button color="accent" class="alert-button">Ok</button>
        </div>
      </div>
    }

    <div class="footer">
      <ul class="zone-menu">
        <li>
          @if (!haveAccess('4-1')) {
            <span class="lock"></span>
          }
          @if (haveAccess('4-1')) {
            <a class="menu-item" [routerLink]="[ '/game/south-america-1' ]" routerLinkActive="active">1</a>
          }
        </li>
        <li>
          @if (!haveAccess('4-2')) {
            <span class="lock"></span>
          }
          @if (haveAccess('4-2')) {
            <a class="menu-item" [routerLink]="[ '/game/south-america-2' ]" routerLinkActive="active">2</a>
          }
        </li>
        <li>
          @if (!haveAccess('4-3')) {
            <span class="lock"></span>
          }
          @if (haveAccess('4-3')) {
            <a class="menu-item" [routerLink]="[ '/game/south-america-3' ]" routerLinkActive="active">3</a>
          }
        </li>
      </ul>
      <img class="footer-bg" src="assets/images/zones/south-america-3/footer.png">
    </div>

    <audio id="continentHover">
      <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
    </audio>
    <audio id="continentClick">
      <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
    </audio>
